export default {
    getTravelTimes: { method: 'get', url: 'travel_times' },
    postTravelTime: { method: 'post', url: 'travel_times' },
    putTravelTime: { method: 'put', url: 'travel_times/{id}' },
    deleteTravelTime: { method: 'delete', url: 'travel_times/{id}' },
}
